export const VISION_X = 4;
export const IDEAL = 6;
export const EVERNEXT = 9;
export const IDEAL_WINDOWS_11 = 13;
export const VISION_X_WINDOWS_11 = 14;

/*
 * Returns true if the scannerId corresponds to a scanner that uses the ronline-paninievernext API.
 * For VisionX and IDeal users, we only want to connect to the ronline-paninievernext API if they
 * explicitly select the Panini Everest option. Otherwise, they will use the Web Scanning Service BAU flow.
 */

export const isPaniniAPIScanner = scannerId =>
  scannerId === EVERNEXT || scannerId === IDEAL_WINDOWS_11 || scannerId === VISION_X_WINDOWS_11;
